import { render } from "./CheckBoxes.vue?vue&type=template&id=5211b63b"
import script from "./CheckBoxes.vue?vue&type=script&lang=js"
export * from "./CheckBoxes.vue?vue&type=script&lang=js"

import exportComponent from "/codebuild/output/src827224769/src/frontend-broker/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__